import PATHS from "./path";
import { lazy } from "react";
const LoginPage = lazy(() => import("pages/login"));
const AuthorizePage = lazy(() => import("pages/client/authorize"));
const PortalPage = lazy(() => import("pages/portal"));
const UnauthorizedPage = lazy(() => import("pages/unauthorized"));
const NotFoundClientPage = lazy(() => import("pages/notfound"));
const LogoutPage = lazy(() => import("pages/client/logout"));
const OAuth2CallbackPage = lazy(() => import("pages/callback/oauth2/login"));
const ReportPage = lazy(() => import("pages/report"));
export interface RoutePropsI { name: string; component: any; path: string; routes?: RoutePropsI[]; key: string; }
// Public: không cần login
export const ROUTE_PAGE_PUBLIC: RoutePropsI[] = [
  {
    name: "PortalLoginCallback",
    component: OAuth2CallbackPage,
    path: PATHS.PORTAL_LOGIN_CALLBACK,
    key: "PortalLoginCallback",
  },
  {
    name: "Login",
    component: LoginPage,
    path: PATHS.LOGIN,
    key: "login",
  },
  {
    name: "Authorize",
    component: AuthorizePage,
    path: PATHS.AUTHORIZE,
    key: "authorize",
  },
  {
    name: "LogoutPage",
    component: LogoutPage,
    path: PATHS.CLIENT_LOGOUT,
    key: "logoutPage",
  },
  {
    name: "Portal",
    component: PortalPage,
    path: PATHS.PORTAL,
    key: "portal",
  },
  {
    name: "Unauthorized",
    component: UnauthorizedPage,
    path: PATHS.FORBIDDEN,
    key: "unauthorized",
  },
  {
    name: "NotFound",
    component: NotFoundClientPage,
    path: PATHS.NOT_FOUND,
    key: "notFound",
  },
  {
    name: "Report",
    component: ReportPage,
    path: PATHS.REPORT,
    key: "report",
  }
];

// Private: cần login là được
export const ROUTE_PAGE_PRIVATE: RoutePropsI[] = [

];

// Permission-based: map với quyền BE trả về
export const ROUTE_PAGE_PERMISSION: RoutePropsI[] = [
];
